import React, { PropTypes } from 'react';

const MembershipPost = props => {
  const {
    post,
  } = props;

  return (
    <div style={{ clear: 'both' }}>
      <div style={{ marginTop: '10px' }}>
        <a href={post.link} target="_blank"><img src={post.images} width="100" /></a>
      </div>
    </div>
  );
};

MembershipPost.propTypes = {
  post: PropTypes.object,
};

export default MembershipPost;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/postTypes/membership.jsx